// extracted by mini-css-extract-plugin
export const container = "menuSidebar-module--container--1aQef";
export const shadow = "menuSidebar-module--shadow--2RlD5";
export const shadowExit = "menuSidebar-module--shadow-exit--7NYWq";
export const isOpen = "menuSidebar-module--isOpen--3ciFV";
export const shadowEnter = "menuSidebar-module--shadow-enter--3cBTr";
export const menuHeader = "menuSidebar-module--menuHeader--3_LW9";
export const icon = "menuSidebar-module--icon--2Tg_x";
export const close = "menuSidebar-module--close--1MYyo";
export const menuBody = "menuSidebar-module--menuBody--2v7Pr";
export const menu = "menuSidebar-module--menu--1fN71";